import type { CountryForSelect } from '@packages/domain/models/country';

const sortCountriesByLabel = (countries: CountryForSelect[]) =>
  countries.sort((a, b) => a.label.localeCompare(b.label));

export { sortCountriesByLabel };
